import React, { useEffect, useState } from 'react'
import { compose } from 'recompose'
import { withGoogleMap, GoogleMap as ReactGoogleMap } from 'react-google-maps'
import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer'
import Marker from './Marker'
import Modal from 'react-modal';
import Tank from 'components/Page/Home/Tank'
import './../../shared/Map/styles.css'
import Tooltip from '@material-ui/core/Tooltip';
import { positions } from '@material-ui/system'
import { relative } from 'path'
import { GEOZONES } from 'utils/constants'

const clusterStyles = [
  {
    textColor: 'white',
    textSize: 13.5,
    url: '/images/map/c1.svg',
    height: 65,
    width: 65,
  },
  {
    textColor: 'white',
    textSize: 14.5,
    url: '/images/map/c2.svg',
    height: 85,
    width: 85,
  },
]

const GoogleMap = compose(withGoogleMap)(({ geo, onMarkerClicked, geoZoneSelected }) => {
  const [map, setMap] = useState(null)
  const [loctank, setTank] = useState([]);
  const [markerLat, setMarkerLat] = useState(null);
  const [markerLng, setMarkerLng] = useState(null)
  const [filterDate, setFilterDate] = useState(null)
  const [preZoom, setPreZoom] = useState(null)
  const [zoomLoad, setZoomLoad] = useState(4)
  //const [center, setCenter] = useState({ lat: -24.355913, lng: 133.697059 })
  const [fullScreen, setFullScreen] = useState(true)
  const [modalDiv, setModalDiv] = useState('divModalParentHide')
  const [modalDivChild, setModalDivChild] = useState('divModalChildHide')
  const [modalDivClose, setModalDivClose] = useState('divModalCloseHide')
  const [isOpenModal, setIsopenModal] = useState(false);
  let filterSelectionDate = localStorage.getItem('currentDate');
 //const [zoneSelected, setzoneSelected] = useState(null)

  function toggleModal() {
    setZoomLoad(map.getZoom());
    setModalDiv('divModalParentHide');
    setModalDivChild('divModalChildHide');
    setModalDivClose('divModalCloseHide');
  }

  function handleClusterClick(cluster) {
    if (isOpenModal == false) {
      if (map) {
        var mapDiv = document.getElementsByClassName("gm-style");
        mapDiv[0].appendChild(document.getElementById('divModalParent'))
      }
    }
    setIsopenModal(true);
    if (map !== null && map.getZoom() == preZoom) {
      var date = localStorage.getItem('currentDate');
      setFilterDate(date);
      setZoomLoad(map.getZoom());
      const markers = cluster.getMarkers()
      var tankData = [];
      var lat, lng;

      for (var i = 0; i < markers.length; i++) {
        if (markers[i].getPosition() !== undefined) {
          lat = markers[i].getPosition().lat();
          lng = markers[i].getPosition().lng();
          var title = markers[i].getTitle();
          {
            geo.map(loc => {
              if (loc.tank.deviceID == title) {
                tankData.push(loc.tank);
              }
            })
          }
        }
      }
      setModalDiv('divModalParent');
      setModalDivChild('divModalChild');
      setModalDivClose('divModalClose');
      setMarkerLat(lat);
      setMarkerLng(lng)
      setTank(tankData);
    }
    if (map !== null) { setPreZoom(map.getZoom()); }
  }

  useEffect(() => {
    //setzoneSelected(geoZoneSelected);
    if (filterDate != filterSelectionDate) {
      const markerBounds = new (window as any).google.maps.LatLngBounds()
      geo.forEach(loc => {
        markerBounds.extend(new (window as any).google.maps.LatLng(loc.latitude, loc.longitude))
      })
      if (map) map.fitBounds(markerBounds)
      setFullScreen(true);
    }
    else {
      const markerBounds = new (window as any).google.maps.LatLngBounds()
      markerBounds.extend(new (window as any).google.maps.LatLng(markerLat, markerLng))
      if (map) map.fitBounds(markerBounds)
      setFullScreen(true);
    }
    //Not to reload again if state changes..with same zone selected  DO NOT DELETE THIS CODE ref{setmap} issue 
    // if (geoZoneSelected !== zoneSelected) {
    //   //Check if zone is selected. Blank means no selection
    //   if (geoZoneSelected !== '') {
    //     let obj = GEOZONES.find(o => o.key === geoZoneSelected);
    //     if (obj !== undefined && obj.location !== undefined) {
    //       setCenter({ lat: obj.location[0].lat, lng: obj.location[0].lng });
    //       setZoomLoad(14);
    //     }
    //     else {
    //       //Reset to original state
    //       setCenter({ lat: -24.355913, lng: 133.697059 });
    //       setZoomLoad(4);
    //     }
    //   }
    //   else {
    //     //Reset to original state
    //     setCenter({ lat: -24.355913, lng: 133.697059 });
    //     setZoomLoad(4);
    //   }
    // }
  })
  return (
    <div>
      <div id='divModalParent' className={modalDiv} >
        <div className={modalDivClose} style={{ float: "left", width: '406px', marginLeft: '10px' }}><Tooltip title="Close"><button onClick={toggleModal} style={{ float: 'right', border: '0px', backgroundColor: "white" }}>X</button></Tooltip></div>
        <div id='divModalChild' className={modalDivChild}>
          {loctank.map(loc => (
            <Tank key={loc.deviceID} tank={loc} onClick={() => { onMarkerClicked(loc.deviceID) }} />
          ))}
        </div>
      </div>

      <div id="google-maps" style={{ position: 'relative', zIndex: 1 }}>
        <ReactGoogleMap
           ref={setMap}
          center={{ lat: -24.355913, lng: 133.697059 }}
          //center={center}
          options={{
            streetViewControl: false,
            fullscreenControl: fullScreen,
            gestureHandling: 'cooperative',
            zoom: zoomLoad,
          }}
        >
          <MarkerClusterer
            minimumClusterSize={2}
            zoomOnClick={true}
            gridSize={60}
            styles={clusterStyles}
            onClick={(cluster) => { handleClusterClick(cluster) }}
          >
            <div>
              {geo.map(loc => (
                <Marker key={loc.tank.deviceID} loc={loc} onClick={onMarkerClicked} geoZoneSelected={geoZoneSelected}>
                </Marker>
              ))}
            </div>
          </MarkerClusterer>
        </ReactGoogleMap>
      </div>
    </div>
  )
})
export default GoogleMap
